<template>
    <div class="form-group">
        <slot />
        <div class="mt-2" v-if="validator?.$errors?.length">
            <div
                class="v-input__details"
                v-for="error in validator.$errors"
                :key="error.$uid"
            >
                <div>
                    <div>
                        <div class="text-error">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    validator: Object,
});
</script>
